<!-- @format -->

@if (this.calculationConfig | async; as calculationConfigForPerson) {
  <ng-container *transloco="let t">
    @if (this.enrolment.studyRightId) {
      <sis-description-list [columnCount]="1">
        <dl>
          @if (calculationConfigForPerson.requirementRules; as rules) {
            @if (rules | sortRequirementRules: "TRUE"; as trueRules) {
              @if (trueRules.length > 0) {
                <ng-template #listItem>
                  <dt>{{ t("ENROLMENTS.ENROLMENT_DIALOG.REQUIREMENT_RULES.RESULT_TRUE") }}</dt>
                  <dd>
                    <app-requirement-rules [rules]="trueRules"></app-requirement-rules>
                  </dd>
                </ng-template>
              }
            }
            @if (rules | sortRequirementRules: "FALSE"; as falseRules) {
              @if (falseRules.length > 0) {
                <ng-template #listItem>
                  <dt>{{ t("ENROLMENTS.ENROLMENT_DIALOG.REQUIREMENT_RULES.RESULT_FALSE") }}</dt>
                  <dd>
                    <app-requirement-rules [rules]="falseRules"></app-requirement-rules>
                  </dd>
                </ng-template>
              }
            }
          }
        </dl>
      </sis-description-list>
    }
  </ng-container>
}
